import { isNotUndefined } from '../Utils/Utils';
import { isDeinitable } from './isDeinitable';
export class DependencyContainer {
    constructor() {
        this.factory = new Map();
        this.dependencies = new Map();
    }
    deinit() {
        this.factory.clear();
        const deps = this.getAll();
        for (const dep of deps) {
            if (isDeinitable(dep)) {
                dep.deinit();
            }
        }
        this.dependencies.clear();
    }
    getAll() {
        return Array.from(this.dependencies.values()).filter(isNotUndefined);
    }
    bind(sym, maker) {
        this.factory.set(sym, maker);
    }
    get(sym) {
        const dep = this.dependencies.get(sym);
        if (dep) {
            return dep;
        }
        const maker = this.factory.get(sym);
        if (!maker) {
            throw new Error(`No dependency maker found for ${sym.toString()}`);
        }
        const instance = maker();
        if (!instance) {
            /** Could be optional */
            return undefined;
        }
        this.dependencies.set(sym, instance);
        return instance;
    }
}
